import ClipboardShareController from "./clipboard_share_controller"

// Share the public profile URL from the profile screens (issue #602). All
// behaviour lives in the shared base; this subclass only fixes the
// `profile-share` identifier (data-attributes `data-profile-share-*`).
export default class extends ClipboardShareController {}
